/** Типы исходящего письма*/
export enum PkOutgoingKinds
{
    /** Ответ на обращение физ. лица*/
    ResponseToIndRequestId = "d88d9f5e-69f7-402d-8a60-1688b6b4ff09",

    /** Ответ на обращение физ. лица*/
    ResponseToIndRequestName = "Ответ на обращение физ. лица",

    /** Уведомление о результатах тендера*/
    NotificationOfTenderResultsId = "cb3f5129-20ef-4b3f-bea0-e98c824353b5",

    /** Уведомление о результатах тендера*/
    NotificationOfTenderResultsName = "Уведомление о результатах тендера",

    /** Отзыв доверенности*/
    PowerOfAttorneyRevocationId = "076589c7-4606-4d39-b642-e98715cac574",

    /** Отзыв доверенности*/
    PowerOfAttorneyRevocationName = "Отзыв доверенности",

    /** Претензия*/
    ClaimId = "e18efb86-b363-494a-8871-586a59b60d0d",

    /** Претензия*/
    ClaimName = "Отзыв доверенности"
}